import React, { useState } from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const EXAMENS = [
  { key: "radio_standard", label: "Radiographies standards" },
  { key: "echographie",    label: "Échographies" },
  { key: "tdm",            label: "TDM" },
  { key: "irm",            label: "IRM" },
  { key: "autre_radio",    label: "Autre examen radiologique" },
];

const EMPTY_RESULTAT = { date: "", region_exploree: "", conclusions_radiologue: "" };

const TabImagerie = ({ form, onChange, getConfidence, activeSub }) => {
  const gc = getConfidence || (() => ({ exists: false }));
  const currentSub = activeSub || "radio_standard";

  const getResultats = (key) =>
    Array.isArray(form[`${key}_resultats`]) ? form[`${key}_resultats`] : [];

  const updateResultat = (key, index, field, value) => {
    const updated = [...getResultats(key)];
    updated[index] = { ...updated[index], [field]: value };
    onChange(`${key}_resultats`, updated);
  };

  const addResultat = (key) => {
    onChange(`${key}_resultats`, [...getResultats(key), { ...EMPTY_RESULTAT }]);
  };

  const removeResultat = (key, index) => {
    onChange(`${key}_resultats`, getResultats(key).filter((_, i) => i !== index));
  };

  const handleOuiNon = (key, value) => {
    onChange(key, value);
    if (value === "oui" && getResultats(key).length === 0) {
      onChange(`${key}_resultats`, [{ ...EMPTY_RESULTAT }]);
    }
  };

  return (
    <div className="rb-fields">

      

      {/* ── Contenu de la sous-tab active ── */}
      {EXAMENS.filter(({ key }) => key === currentSub).map(({ key, label }) => (
        <div key={key} className="rb-subtab-content">

          {/* Oui / Non */}
          <div className="rb-result-header">
            <span className="rb-result-label">
              {label}
              <ConfidenceLabel confidence={gc(key)} />
            </span>
            <div className="rb-oui-non">
              <label className="rb-radio-label">
                <input type="radio" name={key} value="oui"
                  checked={form[key] === "oui"}
                  onChange={() => handleOuiNon(key, "oui")} />
                Oui
              </label>
              <label className="rb-radio-label">
                <input type="radio" name={key} value="non"
                  checked={form[key] === "non"}
                  onChange={() => handleOuiNon(key, "non")} />
                Non
              </label>
            </div>
          </div>

          {/* Blocs dynamiques */}
          {form[key] === "oui" && (
            <>
              {getResultats(key).map((item, index) => (
                <div key={index} style={{ border: "1px solid #e2e8f0", borderRadius: "6px", padding: "1rem", marginBottom: "0.75rem" }}>
                  
                  {key === "autre_radio" && (
                    <div className="rb-field-group">
                      <label>Nom de l'examen</label>
                      <input type="text" placeholder="Ex : TEP-scan, scintigraphie..."
                        value={item.nom_examen ?? ""}
                        onChange={(e) => updateResultat(key, index, "nom_examen", e.target.value)} />
                    </div>
                  )}
                  <div className="rb-field-group">
                    <label>Date</label>
                    <input type="date" value={item.date ?? ""}
                      onChange={(e) => updateResultat(key, index, "date", e.target.value)} />
                  </div>
                  <div className="rb-field-group">
                    <label>Région explorée</label>
                    <input type="text" placeholder="Ex : abdomen, thorax..."
                      value={item.region_exploree ?? ""}
                      onChange={(e) => updateResultat(key, index, "region_exploree", e.target.value)} />
                  </div>
                  <div className="rb-field-group">
                    <label>Conclusions du radiologue</label>
                    <textarea rows={3} placeholder="Conclusions..."
                      value={item.conclusions_radiologue ?? ""}
                      onChange={(e) => updateResultat(key, index, "conclusions_radiologue", e.target.value)} />
                  </div>
                  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.75rem" }}>
                    <button onClick={() => removeResultat(key, index)}
                      className="rb-bloc-btn rb-bloc-btn--remove">
                      🗑 Supprimer
                    </button>
                  </div>
                </div>
              ))}
              <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "0.5rem" }}>
                <button onClick={() => addResultat(key)}
                  className="rb-bloc-btn rb-bloc-btn--add">
                  + Ajouter un résultat
                </button>
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default TabImagerie;